import React, { Component } from 'react';
import '../Footer/Footer';

class Footer extends Component {
  render() {
    return (
      <footer className="sticky-footer">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Copyright © finbooks 2024 v.1.0.5</span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;